import React from 'react';
import { useParams } from 'react-router';
import { LscAuthGate } from '../hooks/useLscAuthGate';
import { ImportSyncConsole } from '../components/ImportSyncConsole';
import CommissionerOnlyGate from '../components/CommissionerOnlyGate';
import { IMPORT_SYNC_PAGE_COPY } from '../leagueNav';
import { lscReturnTo } from '../routing';
import { useLscContentColumn } from '../lscContentColumn';

const LscScheduleImportPage: React.FC = () => {
  useLscContentColumn('narrow');
  const { leagueId } = useParams<{ leagueId: string }>();
  return (
    <LscAuthGate returnTo={lscReturnTo(`/leagues/${leagueId}/import`)}>
      <CommissionerOnlyGate>
        <ImportContent />
      </CommissionerOnlyGate>
    </LscAuthGate>
  );
};

function ImportContent() {
  const { leagueId } = useParams<{ leagueId: string }>();

  return (
    <div className="space-y-8">
      <div>
        <h1 className="text-2xl font-bold text-white mb-1">{IMPORT_SYNC_PAGE_COPY.title}</h1>
        <p className="text-sm text-secondary-400">{IMPORT_SYNC_PAGE_COPY.subtitle}</p>
      </div>
      {leagueId ? <ImportSyncConsole leagueId={leagueId} /> : null}
    </div>
  );
}

export default LscScheduleImportPage;
